import getUrl from 'lib/url'
import { ISelectedOptions } from './reducer'

export const getCars = (queryStr = '', cityName = '北京', offset = 0) => {
  return fetch(getUrl(`/motor/pc/car/brand/get_select_series`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: `offset=${offset}&limit=30&is_refresh=${
      offset ? 0 : 1
    }&city_name=${encodeURIComponent(cityName)}&${queryStr}`,
  }).then(async (res) => {
    const data = await res?.json()
    if (data?.status === 0) {
      return data?.data
    }
    return null
  })
}

export const getParamsFromState = (state: ISelectedOptions) => {
  return Object.entries(state)
    .filter(([, value]) => !!value && value.length > 0)
    .map(([key, value]) => {
      if (!value) {
        return ''
      }
      return `${key}=${value.map((item) => item.param).join(',')}`
    })
    .join('&')
}
